import { motion } from 'framer-motion'

// Utils
import { pageVariants } from 'components/interestform/utils'

import commonStyles from 'components/interestform/slides/common.css'
import styles from './discovery.css'

const Discovery = (): JSX.Element => {
  return (
    <motion.div className={styles.wrapper} initial="initial" animate="in" exit="out" variants={pageVariants}>
      <div className={styles.splitPanel}>
        <div className={styles.leftPanel}>
          <h1 className={commonStyles.heading}>Discovery</h1>
          <div className={commonStyles.subheading}>
            With Tracklib, you can browse, search and discover music to sample through our sleek, modern interface
          </div>
          <div className={commonStyles.textContent}>
            <div className={commonStyles.paragraph}>
              Every week we curate and spotlight labels, artists, genres, and songs, alongside our advanced search functionality where our
              users can dig deep to find exactly what they’re looking for
            </div>
            <div className={commonStyles.paragraph}>
              Our beat loop function is super simple to use and makes it easy for anyone to find the samples to make their beat complete,
              but under the hood it&apos;s a highly complex algorithm that takes all the trouble out of timing
            </div>
            <div className={commonStyles.paragraph}>
              All labels on Tracklib can have their own dedicated section if they wish. Label pages are easy to find, branded with your
              logotype and include a description of your label. We also promote tracks and catalogs through blog posts, social media and
              online beat battles judged by celebrity producers
            </div>
          </div>
        </div>
        <div className={styles.rightPanel}>
          <div>
            <img src="/static/images/interestform/inspiration-screenshot.jpg" alt="Tracklib Homepage Screenshot" className={styles.image} />
          </div>
        </div>
      </div>
    </motion.div>
  )
}

export default Discovery
